import { translate } from "@/plugins/i18n";
import type BaseEnumType from "../../baseEnumType";
import Key from "@/app/types/common/key";
import { Maybe } from "@/components/utils/typeHelpers";


export class EnumEdiSource implements BaseEnumType {
  private static allValues: EnumEdiSource[] = []; // make sure this is top-most
  
  public static freeway = new EnumEdiSource(1, "Freeway", "enum_edi_source_freeway");
  
  public key: number;
  public value: string;
  public translationKey: string;

  private constructor(key: number, value: string, translationKey: string) {
    this.key = key;
    this.value = value;
    this.translationKey = translationKey;
    EnumEdiSource.allValues.push(this);
  }

  public get translation() { return translate(Key.fromString(this.translationKey)); }

  public isFreeway() { return this === EnumEdiSource.freeway; }

  public static getValues(): readonly EnumEdiSource[] {
    return EnumEdiSource.allValues;
  }

  public static getValuesExcept0(): readonly EnumEdiSource[] {
    return EnumEdiSource.allValues.filter((x) => x.key !== 0);
  }

  public static getByKey(key: number): EnumEdiSource {
    const found = EnumEdiSource.allValues.find(e => e.key === key);
    if (found === undefined) {
      throw new Error(`EnumEdiSource - Key not found: ${ key }`);
    }

    return found;
  }

  public static getByValue(name: string, def?: EnumEdiSource): EnumEdiSource {
    const found = name ? EnumEdiSource.allValues.find(e => e.value.toLowerCase() === name.toLowerCase()) : null;
    if (!found) {
      if (def) {
        return def;
      }
      throw new Error(`EnumEdiSource - Value not found: ${ name }`);
    }

    return found;
  }

  public equals(other: Maybe<EnumEdiSource>): boolean {
    return this.key === other?.key;
  }
}